import { isEmpty, toString } from 'lodash';
import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS,
  FUND_INVESTMENTS_TOTAL_WEIGHTING_TITLE,
} from 'pages/FundInvestments/common/constants';
import { displayMessageOnCellTooltip } from 'pages/ValuationsAllocation/util';
import { getObjectValue, parseFloatToFixed } from 'utilities';
import { DisplayTotalComparisonWeightingsParams } from './displayTotalComparisonWeightings.types';

const { weighted: WEIGHTED } = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const displayTotalComparisonWeightings = (params: DisplayTotalComparisonWeightingsParams): void => {
  const { addFeedbackFromCell, parsedCells, totalComparisonWeightings } = params;

  // Find the weighted cell
  const weightedCell = getObjectValue(
    Object.values(getObjectValue(parsedCells)).find(parsedCell => {
      const { customKey } = getObjectValue(parsedCell);
      return customKey === WEIGHTED.key;
    })
  );

  // If the weighted cell does not exist, exit early
  if (isEmpty(weightedCell)) {
    return;
  }

  // Clear previous tooltip messages from the weighted cell
  weightedCell.tooltipMessages = [];

  // Show the total comparison weightings as a tooltip on the weighted cell
  displayMessageOnCellTooltip({
    addFeedbackFromCell,
    cell: weightedCell,
    message: `${FUND_INVESTMENTS_TOTAL_WEIGHTING_TITLE}: ${parseFloatToFixed(
      toString(totalComparisonWeightings),
      2 // Fraction digits
    )}%`,
  });
};

export default displayTotalComparisonWeightings;
